export * from './app-sidebar-form.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-form/index.ts